import getStore from "../store/store";
import isClassicIndentedViewFlightEnabled from "../utils/isClassicIndentedViewFlightEnabled";

export default function getClassicIndentedViewEnabled(): boolean {
    if (!isClassicIndentedViewFlightEnabled()) {
        return false;
    }
    
    return getStore().isClassicIndentedView ?? false;
}
